"use client";

import { EmptyState } from "@/components/shared/empty-state";
import type { PostType } from "@/contexts/feed-context";
import { usePostContext } from "@/contexts/post-context";
import type { Post } from "@/graphql/codegen/graphql";
import { cn } from "@/utils/lib";
import type { Maybe } from "@/utils/types";

import { PostCompactActivity } from "../post-activity/post-compact-activity";
import { PostHeaderBody } from "../post-header-body";
import { PostStatusRow } from "../post-status-row";

type PostDetails = {
  className?: Maybe<string>;
  post: Post | PostType;
  showRepost?: boolean;
  isParentPost?: boolean;
};

export const SinglePostDetails = ({
  className = "",
  post,
  isParentPost = false,
  showRepost = true,
}: PostDetails) => {
  const { isPostRemoved } = usePostContext();

  if (!post) return null;

  if (isPostRemoved) {
    return (
      <EmptyState
        image="/assets/empty-3.png"
        title="This post has been removed."
        description=""
      />
    );
  }

  return (
    <div>
      <PostStatusRow section="detail" />

      <div
        className={cn(
          `
            p-3 pb-0
            md:p-6 md:pb-0
            xl:p-8 xl:pt-6 xl:pb-0
          `,
          className,
          {
            "cursor-pointer border-b border-border-light": isParentPost,
          },
        )}
      >
        <PostHeaderBody
          {...{
            showRepost,
            GatedContentBodyClass: "px-4",
            PostBodyClass: "px-0",
          }}
        />
        {isParentPost && post.poster?.publicKey && post?.postHash && (
          <div className="pb-6">
            <PostCompactActivity
              creatorPublicKey={post.poster?.publicKey}
              postHash={post?.postHash}
            />
          </div>
        )}
      </div>
    </div>
  );
};
